












































import { Vue, Component } from 'vue-property-decorator';
import RankList from '@/RankList';
import NewsList from '@/NewsList';
import FavoriteCard from '@/FavoriteCard';
import { getKnowledgeDetail } from 'service/api';
import { KnowDetail, KnowDetailRes } from 'src/types/views/know';

@Component({
  components: {
    RankList,
    NewsList,
    FavoriteCard,
  },
})
export default class Service extends Vue {
  fontSize = 14;

  detail: KnowDetail = {
    id: 0,
    title: '',
    knowledgetypename: '',
    releaseTime: '',
    releaseOrganization: '',
    content: '',
    favorite: false,
  };

  async getDetail(id: string) {
    const res = await getKnowledgeDetail({ id });
    this.detail = (res as KnowDetailRes).data.rows;
  }

  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getDetail(id as string);
    }
  }
}
